export const soundConstants = {
    PLAY_WINSOUND  :"SOUND_PLAY_WINSOUND",
    PLAY_LOSTSOUND :"SOUND_PLAY_LOSTSOUND",
    MUTE           :"SOUND_MUTE",
};



// WEBPACK FOOTER //
// ./src/_constants/sound.constants.js